const { ASYNC } = require('../utils/redux-helpers');

module.exports = {
    FETCH_SETTINGS: ASYNC,
    UPDATE_SCHOOL_TEXT: ASYNC,
    UPDATE_ROLE_TEXT: ASYNC
};
